import React from 'react'
import { View, Image, useWindowDimensions } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import Icon from 'react-native-vector-icons/FontAwesome5'
import { useNavigation } from '@react-navigation/native'
import { useMediaQuery } from 'react-responsive'

import Colors from '../constants/Colors'

const backIcon = () => (
  <Icon name="arrow-alt-circle-left" color={Colors.laranja_forte} size={30} />
)

const HeaderInterno = ({title, subtitle = ''}) => {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goHome = () => {
    navigation.navigate('Home')
  }

    return (
      <View style={{position: "absolute", zIndex: 10}}>
        {!isLargeScreen && <View style={{width: windowWidth, height: 80, backgroundColor: Colors.roxo}}>
          <Image source={require('../assets/images/logo_h.svg')} style={{width: windowWidth-140, height: 80, alignSelf: 'center'}} resizeMode="contain" />
        </View>}
        {!isLargeScreen && <View style={{width: windowWidth, height: 10, backgroundColor: Colors.laranja_forte}} />}
        <View style={{width: isLargeScreen ? windowWidth - 400 : windowWidth, height: isLargeScreen ? 70 : 50, backgroundColor: Colors.laranja_claro}}>
          <View style={isLargeScreen ? tailwind('mx-2 mt-5') : tailwind('mx-2 mt-1')}>
            <View style={tailwind('flex-row')}>
              <Button accessoryLeft={backIcon} appearance="ghost" onPress={_goHome} style={{width: 30}} />  
              <Text style={[tailwind('mx-1 mt-4 text-base font-bold'), { color:Colors.roxo }]}>{title}</Text>
            </View>
            {subtitle && <Text style={[tailwind('mx-12 mt-1 text-sm font-bold'), { color:Colors.roxo }]}>{subtitle}</Text>}
          </View>
        </View>
        <Image source={require('../assets/images/bottom_header_interno.svg')} style={{width: isLargeScreen ? windowWidth - 400 : windowWidth, height: isLargeScreen ? 80 : 60, alignSelf: isLargeScreen ? 'flex-start' : 'center'}} resizeMode="cover" />
      </View>
)
  }

export default HeaderInterno
